import ProfileItemForm from "./ProfileItemForm";
import React from "react";
import ProfileJobRow from "../../profiles/components/ProfileJobRow";
import { FormInputComponent } from "../../../components/form/Form";
import { TalentAppCard } from "./TalentAppCard";
import { Input, Select, Checkbox } from "antd";
import dateformat from "dateformat";

export default class JobForm extends ProfileItemForm {

    static ItemType = 'Job'

    static FormClass = 'talent-role-form add-talent-form add-company-form '

    static shouldUseTalentAppCard = true;

    static ShowProfilePreview = true;

    getModelFromProps() {
        let model = { ...(this.props.model || {}) };

        model.is_still_there = (model.is_still_there === 1);
        if (model.started_at) {
            if (typeof model.started_at === 'string') {
                model.started_at = new Date(model.started_at)
            }
            model.started_at_year = model.started_at.getFullYear();
            model.started_at_month = model.started_at.getMonth() + 1;

            if (!model.ended_at && !model.is_still_there) {
                model.is_still_there = true;
            }
        }
        if (model.ended_at) {
            if (typeof model.ended_at === 'string') {
                model.ended_at = new Date(model.ended_at)
            }
            model.ended_at_year = model.ended_at.getFullYear();
            model.ended_at_month = model.ended_at.getMonth() + 1;
        }

        return model;
    }

    creatingNewItem() {
        let {
            is_still_there,
            ...model
        } = this.getModelFromProps();
        return !TB.keys(model).length;
    }

    async onChange(model) {

        let updatedModel = {
            ...model,
            ...this.setDateFromInputs(model, 'started_at'),
            ...this.setDateFromInputs(model, 'ended_at'),
        }
        let resetEndedAtValidation = false;
        if (updatedModel.is_still_there || (!updatedModel.is_still_there && this.state.model.is_still_there)) {
            resetEndedAtValidation = true;
            delete updatedModel.ended_at;
            delete updatedModel.ended_at_year;
            delete updatedModel.ended_at_month;

            if (this.getModelFromProps().ended_at) {
                await this.formRef.current.updateInputsWithValue({ ended_at_year: '', ended_at_month: '' }, false)
            }
        }

        // if (!updatedModel.ended_at_year && updatedModel.ended_at_month && updatedModel.ended_at_month !== '') {
        //     delete updatedModel.ended_at_month;
        //     await this.formRef.current.updateInputsWithValue({ended_at_month:''}, false)
        // }
        // if (!updatedModel.started_at_year && updatedModel.started_at_month && updatedModel.started_at_month !== '') {
        //     delete updatedModel.started_at_month;
        //     await this.formRef.current.updateInputsWithValue({started_at_month:''}, false)
        // }
        await super.onChange(updatedModel);


        let errors = {
            ...this.validateDateBeforeToday('started_at', 'Start date'),
            ...this.validateDateAfterDate('ended_at', 'started_at')
        };

        if (resetEndedAtValidation) {
            errors.ended_at = null
        } else if (errors.ended_at === null) {
            errors = TB.merge(errors, {
                ...this.validateDateBeforeToday('ended_at', 'End date'),
            });
        }

        if (Object.keys(errors).length) {
            await this.formRef.current.updateInputsWithError(errors)
        }

    }

    /**
     * The fields mapping for the form
     */
    // formFields_LEGACY = () => {

    //     // 'jobs.*.employer'       => 'required|string|max:255',
    //     // 'jobs.*.image_path'     => 'nullable|string|max:255', OR 'nullable|image',
    //     // 'jobs.*.description'    => 'nullable|string|max:255',
    //     // 'jobs.*.role'           => 'required|string|max:255',
    //     // 'jobs.*.is_still_there' => 'nullable|boolean',
    //     // 'jobs.*.started_at'     => 'required|date',
    //     // 'jobs.*.ended_at'       => 'nullable|date',


    //     return [
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 employer: {
    //                     type: 'text',
    //                     label: TB.trans('talent.company_form.employer_label'),
    //                     maxLength: 255,
    //                     required: true,
    //                     placeholder: TB.trans('talent.company_form.employer_placeholder'),
    //                     style: styles.field,
    //                     columns: 10
    //                 }
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 role: {
    //                     type: 'text',
    //                     label: TB.trans('talent.company_form.role_label'),
    //                     maxLength: 255,
    //                     required: true,
    //                     placeholder: TB.trans('talent.company_form.role_placeholder'),
    //                     style: styles.field,
    //                     columns: 10
    //                 }
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 started_at: {
    //                     type: 'hidden-date',
    //                     label: TB.trans('talent.company_form.start_date_label'),
    //                     required: false,
    //                     style: styles.field,
    //                     className: 'field hide-input',
    //                     columns: 10
    //                 }
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             className: 'field-section field-section-select',
    //             fields: {
    //                 started_at_month: {
    //                     label: false,
    //                     placeholder: 'Month',
    //                     type: 'select',
    //                     required: false,
    //                     options: this.monthOptions(),
    //                     labelClassName: 'hide-label',
    //                     className: 'field hide-label',
    //                     style: { ...styles.field, paddingRight: 0, maxWidth: 110 },
    //                     hideVisibility: !this.props.isEditing && !this.state.model.started_at_month
    //                 },
    //                 started_at_year: {
    //                     label: false,
    //                     placeholder: 'Year',
    //                     type: 'select',
    //                     required: parseInt(this.state.model.started_at_month) > 0,
    //                     labelClassName: 'hide-label',
    //                     options: this.yearOptions(),
    //                     validations: {

    //                         need_year: ({ model }, value) => {
    //                             if (model.started_at_month && (value === '' || TB.isNaN(value))) {
    //                                 return 'Year is required with a month'
    //                             }

    //                             return true;
    //                         }
    //                     },
    //                     style: { ...styles.field, maxWidth: 110 },
    //                     hideVisibility: !this.props.isEditing && !this.state.model.started_at_year
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 ended_at: {
    //                     type: 'hidden-date',
    //                     label: TB.trans('talent.company_form.end_date_label'),
    //                     required: false,
    //                     style: styles.field,
    //                     className: 'field hide-input',
    //                     columns: 10,
    //                     hideVisibility: (!this.props.isEditing && !this.state.model.ended_at) ||
    //                         (this.props.isEditing && this.state.model.is_still_there)
    //                 }
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             className: 'field-section field-section-select',
    //             fields: {
    //                 ended_at_month: {
    //                     label: false,
    //                     placeholder: 'Month',
    //                     type: 'select',
    //                     required: false,
    //                     options: this.monthOptions(),
    //                     labelClassName: 'hide-label',
    //                     className: 'field hide-label',
    //                     style: { ...styles.field, paddingRight: 0, maxWidth: 110 },
    //                     hideVisibility: (!this.props.isEditing && !this.state.model.ended_at_month) ||
    //                         (this.props.isEditing && this.state.model.is_still_there)
    //                 },
    //                 ended_at_year: {
    //                     label: false,
    //                     placeholder: 'Year',
    //                     type: 'select',
    //                     required: parseInt(this.state.model.ended_at_month) > 0,
    //                     labelClassName: 'hide-label',
    //                     validations: {

    //                         need_year: ({ model }, value) => {
    //                             if (model.ended_at_month && (value === '' || TB.isNaN(value))) {
    //                                 return 'Year is required with a month'
    //                             }

    //                             return true;
    //                         }
    //                     },
    //                     options: this.yearOptions(),
    //                     style: { ...styles.field, maxWidth: 110 },
    //                     hideVisibility: (!this.props.isEditing && !this.state.model.ended_at_year) ||
    //                         (this.props.isEditing && this.state.model.is_still_there)
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 is_still_there: {
    //                     label: TB.trans('talent.company_form.still_employed_label'),
    //                     type: 'checkbox',
    //                     required: false,
    //                     style: styles.field,
    //                     columns: 4,
    //                     hideVisibility: !this.props.isEditing && !this.state.model.is_still_there
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 image_path: {
    //                     label: TB.trans('talent.company_form.company_logo_label'),
    //                     type: 'pixie',
    //                     ratio: '1:1',
    //                     freeCrop: true,
    //                     minWidth: 50,
    //                     minHeight: 50,
    //                     width: 200,
    //                     circular: false,
    //                     required: false,
    //                     style: styles.field,
    //                     columns: 8,
    //                     hideVisibility: !this.props.isEditing && !this.state.model.image_path
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 description: {
    //                     label: TB.trans('talent.company_form.summary_paragraph_label'),
    //                     placeholder: TB.trans('talent.company_form.summary_paragraph_placeholder'),
    //                     type: 'textarea',
    //                     required: false,
    //                     style: styles.field,
    //                     maxLength: 10000,
    //                     columns: 10,
    //                     rows: 10
    //                 },
    //             }
    //         },
    //     ];
    // };

    renderTitle() {
        return null;
    }

    renderFormFields() {
        const { isEditing } = this.props;

        if (isEditing) {
            return (
                <TalentAppCard.Section>
                    {this.renderFormData()}
                </TalentAppCard.Section>
            )
        }

        return (
            <TalentAppCard.Section>
                {this.renderFormattedData()}
            </TalentAppCard.Section>
        )
    }

    renderFormData = () => {
        const { disabled, isEditing } = this.props;
        const isDisabled = disabled || !isEditing;
        const monthOptions = this.monthOptions();
        const yearOptions = this.yearOptions();

        return (
            <div>
                <div className="flex flex-col sm:flex-row gap-4">
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="employer"
                            label={TB.trans('talent.company_form.employer_label')}
                            maxLength={255}
                            required
                            value={this.state.model.employer}
                        >
                            <Input
                                placeholder={TB.trans('talent.company_form.employer_placeholder')}
                                disabled={isDisabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="role"
                            label={TB.trans('talent.company_form.role_label')}
                            maxLength={255}
                            required
                            value={this.state.model.role}
                        >
                            <Input
                                placeholder={TB.trans('talent.company_form.role_placeholder')}
                                disabled={isDisabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                </div>

                <div className="flex flex-col gap-4 field-section field-section-select">
                    <div className="field hide-input">
                        <FormInputComponent
                            type="hidden-date"
                            fieldName="started_at"
                            label={TB.trans('talent.company_form.start_date_label')}
                            required={false}
                            value={this.state.model.started_at}
                        />
                        <div className="flex flex-row gap-2">
                            <div style={{ maxWidth: 130 }}>
                                <FormInputComponent
                                    fieldName="started_at_month"
                                    type="select"
                                    label={false}
                                    placeholder="Month"
                                    required={false}
                                    options={monthOptions}
                                    labelClassName="hide-label"
                                    className="field hide-label"
                                    value={this.state.model.started_at_month}
                                />
                            </div>
                            <div style={{ maxWidth: 130 }}>
                                <FormInputComponent
                                    fieldName="started_at_year"
                                    type="select"
                                    label={false}
                                    placeholder="Year"
                                    required={parseInt(this.state.model.started_at_month) > 0}
                                    options={yearOptions}
                                    labelClassName="hide-label"
                                    value={this.state.model.started_at_year}
                                    validations={{
                                        need_year: ({ model }, value) => {
                                            if (model.started_at_month && (value === '' || TB.isNaN(value))) {
                                                return 'Year is required with a month'
                                            }
                                            return true;
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {!this.state.model.is_still_there && (
                        <div className="field-section field-section-select">
                            <div className="field hide-input">
                                <FormInputComponent
                                    type="hidden-date"
                                    fieldName="ended_at"
                                    label={TB.trans('talent.company_form.end_date_label')}
                                    required={false}
                                    value={this.state.model.ended_at}
                                />
                                <div className="flex flex-row gap-2">
                                    <div style={{ maxWidth: 130 }}>
                                        <FormInputComponent
                                            fieldName="ended_at_month"
                                            type="select"
                                            label={false}
                                            placeholder="Month"
                                            required={false}
                                            options={monthOptions}
                                            labelClassName="hide-label"
                                            className="field hide-label"
                                            value={this.state.model.ended_at_month}
                                        />
                                    </div>
                                    <div style={{ maxWidth: 130 }}>
                                        <FormInputComponent
                                            fieldName="ended_at_year"
                                            type="select"
                                            label={false}
                                            placeholder="Year"
                                            required={parseInt(this.state.model.ended_at_month) > 0}
                                            options={yearOptions}
                                            labelClassName="hide-label"
                                            value={this.state.model.ended_at_year}
                                            validations={{
                                                need_year: ({ model }, value) => {
                                                    if (model.ended_at_month && (value === '' || TB.isNaN(value))) {
                                                        return 'Year is required with a month'
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <FormInputComponent
                        fieldName="is_still_there"
                        label={TB.trans('talent.company_form.still_employed_label')}
                        type="checkbox"
                        required={false}
                        value={this.state.model.is_still_there}
                    />

                    <FormInputComponent
                        fieldName="image_path"
                        label={TB.trans('talent.company_form.company_logo_label')}
                        type="pixie"
                        ratio="1:1"
                        freeCrop
                        minWidth={50}
                        minHeight={50}
                        width={200}
                        circular={false}
                        required={false}
                        value={this.state.model.image_path}
                    />

                    <FormInputComponent
                        fieldName="description"
                        label={TB.trans('talent.company_form.summary_paragraph_label')}
                        type="antd-input"
                        required={false}
                        maxLength={10000}
                        value={this.state.model.description}
                    >
                        <Input.TextArea
                            placeholder={TB.trans('talent.company_form.summary_paragraph_placeholder')}
                            disabled={isDisabled}
                            className="input-default"
                            rows={6}
                            maxLength={10000}
                        />
                    </FormInputComponent>
                </div>
            </div>
        )
    }

    renderFormattedData() {
        const { employer, role, started_at, ended_at, is_still_there, image_path, description } = this.state.model;

        const formatDate = (date) => {
            if (!date) return null;
            if (typeof date === 'string') date = new Date(date);
            return dateformat(date, 'mmm yyyy');
        };

        const startDate = formatDate(started_at);
        const endDate = is_still_there ? 'Present' : formatDate(ended_at);

        return (
            <div className="flex flex-col sm:flex-row items-start gap-4">
                {image_path && (
                    <div className="shrink-0">
                        <img
                            src={image_path}
                            alt={`${employer} logo`}
                            className="h-[48px] w-[48px] rounded object-contain"
                        />
                    </div>
                )}
                <div className="flex-1 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-x-6 gap-y-1 mb-1">
                        <p className="text-sm font-semibold m-0 truncate">{role || '—'}</p>
                        <p className="text-sm text-gray-600 m-0 truncate">{employer || '—'}</p>
                    </div>
                    {(startDate || endDate) && (
                        <p className="text-xs text-gray-500 m-0">
                            {startDate}{startDate && endDate ? ' — ' : ''}{endDate}
                        </p>
                    )}
                    {description && (
                        <p className="text-xs text-gray-600 mt-2 m-0 line-clamp-2">{description}</p>
                    )}
                </div>
            </div>
        )
    }

    renderFormFooterInfo() {
        return <div />
    }

    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}
            >
                Edit Job
            </button>
        );
    }

    renderProfilePreview() {
        return (
            <TalentAppCard.Section>
                <ProfileJobRow job={this.getModelFromProps()} />
            </TalentAppCard.Section>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};